import { Link } from "react-router-dom";

interface BlogCardProps {
  title: string;
  excerpt: string;
  image: string;
  author: string;
  date: string;
  categories: string[];
  slug: string;
}

const BlogCard = ({ title, excerpt, image, author, date, categories, slug }: BlogCardProps) => {
  const isSighting = slug.startsWith("__sighting__");
  const linkTo = isSighting ? `/sightings/${slug.replace("__sighting__", "")}` : `/blog/${slug}`;
  return (
    <Link to={linkTo} className="group">
      <article className="bg-card rounded-xl overflow-hidden border border-border hover:border-accent/30 transition-all duration-300 hover:shadow-lg hover:shadow-accent/5">
        <div className="relative w-full overflow-hidden" style={{ paddingBottom: '56.25%' }}>
          <img
            src={image}
            alt={title}
            className="absolute inset-0 object-cover w-full h-full group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-5">
          <div className="flex gap-2 mb-3">
            {categories.map((category) => (
              <span
                key={category}
                className="text-xs font-medium tracking-wide uppercase px-2 py-0.5 bg-secondary text-muted-foreground rounded"
              >
                {category}
              </span>
            ))}
          </div>
          <h3 className="text-lg font-bold mb-2 group-hover:text-accent transition-colors line-clamp-2 text-foreground leading-snug">
            {title}
          </h3>
          <p className="text-muted-foreground mb-4 line-clamp-2 text-sm leading-relaxed">{excerpt}</p>
          <div className="flex items-center text-xs text-muted-foreground">
            <span>{author}</span>
            <span className="mx-2">·</span>
            <span>{date}</span>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default BlogCard;
